import { SvgIcon, SvgIconProps } from '@mui/material';

export const WhitOutImgIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M24.3333 12.6667C24.3333 18.1664 24.3333 20.9162 22.6248 22.6248C20.9162 24.3333 18.1664 24.3333 12.6667 24.3333C7.16695 24.3333 4.41709 24.3333 2.70854 22.6248C1 20.9162 1 18.1664 1 12.6667C1 7.16695 1 4.41709 2.70854 2.70854C4.41709 1 7.16695 1 12.6667 1" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M1 13.2499L3.04352 11.4618C4.10667 10.5316 5.70899 10.5849 6.7079 11.5838L11.7126 16.5885C12.5143 17.3903 13.7764 17.4996 14.7041 16.8476L15.052 16.6031C16.387 15.6649 18.1931 15.7736 19.4059 16.8652L23.1667 20.2499" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M24.332 1.00003L17.332 8M17.332 1L24.332 7.99997" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  );
};
